export const notificationPaths = {
  base: 'notification',
  notifications: 'notifications',
};

export const notificationRoutes = {
  notificationsPageView: `${notificationPaths.base}/${notificationPaths.notifications}`,
};
